<template>
  <div class="document-color">
    <label v-if="label" class="document-color__label c-input-label">{{ label }}</label>

    <div class="document-color__body">
      <color-picker
        ref="picker"
        :value="value"
        :validate="validate"
        :default-color="defaultColor"
        @input="onInput"
      ></color-picker>
      <div
        class="document-color__icon"
        :style="{
          color: value || defaultColor,
        }"
      >
        <svg width="10" height="13" viewBox="0 0 10 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125"
            stroke="currentColor"
            stroke-width="2"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import ColorPicker from "@/components/controls/colorpicker";

export default {
  components: {
    "color-picker": ColorPicker,
  },
  props: ["label", "value", "validate", "defaultColor"],
  computed: {
    isValid() {
      return this.$refs.picker.isValid;
    },
  },
  methods: {
    onInput(evt) {
      this.$emit("input", evt);
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/styles/vars";
.document-color {
  display: flex;
  flex-direction: column;
  &__body {
    display: flex;
  }
  &__icon {
    margin-left: 14px;
    vertical-align: top;
    margin-top: 2px;
  }
  &__label {
    font-size: 12px;
    color: $color-label;
    line-height: 13px;
    margin-bottom: 5px;
  }
}
</style>
